module.exports = __webpack_public_path__ + "img-front/register/kinesis-third.71aa74a2.svg";